// extracted by mini-css-extract-plugin
export default {"cartPage":"styles_cartPage__e8AMX","empty":"styles_empty__AQw6L","empty__img":"styles_empty__img__jWRim","empty__text":"styles_empty__text__uQHiZ"};